import script from "./hsydScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./hsydScreen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__